module.exports = __webpack_public_path__ + "static/img/h3.d4a4d81.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/hor/h3.jpg
// module id = Y4QC
// module chunks = 1